import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ILookupService, IdValuePair, LookupCriteria } from "@tylertech/tyler-api-types";
@Injectable()
export class UBAccountLookupService implements ILookupService<IdValuePair>
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    Lookup(criteria: LookupCriteria): Promise<IdValuePair[]>
    {
        return this.$apiService.sendAuth("IAccountService/LookupAccount", criteria);
    }
}
